import { ServiceNowArticle } from './article.model';

interface BaseDecision {
  id: number;
  title: string;
  order: number;
  lastUpdatedBy: string;
  lastUpdatedAt: string;
  tags: string[];
  status: DecisionStatus;
  note: string;
  path: string[];
  averageRating: number;
  countOfRates: number;
}

export interface PopularSolution {
  description: string;
  hasVideo: boolean;
  id: number;
  link: string;
  parentId: number;
  path: string;
  popularOrder: number;
  serviceNowArticleNumber: string;
  title: string;
  type: DecisionType.faq | DecisionType.request | DecisionType.externalLink;
  vpnRequired: boolean;
  memberFirm: string;
}

export interface Solution extends BaseDecision {
  type: DecisionType.faq | DecisionType.request | DecisionType.externalLink;
  parentId: number;
  link: string;
  description: string;
  serviceNowArticleNumber: string;
  lastUpdatedArticleAt: Date;
  source: SolutionSource;
  countOfView: number;
  serviceNowArticleCountOfView: number;
  hasVideo: boolean;
  vpnRequired: boolean;
  isPopular: boolean;
  isHighlyRated: boolean;
  isMostViewed: boolean;
  memberFirmIds: number[];
  pathIds: string[];
  supportAreaId: number;
}

export interface RootCategory extends BaseDecision {
  type: DecisionType.rootCategory;
  iconId: IconType;
  description: string;
  containerFor: ContainerFor;
  voiceLinkId: number;
  chatLinkId: number;
  hasChildren: boolean;
  voiceLink: string;
  chatLink: DecisionChatLink;
  showChatLink: boolean;
  isNew: boolean;
  memberFirmIds: number[];
  supportAreaId: number;
}

export interface Category extends BaseDecision {
  type: DecisionType.category;
  containerFor: ContainerFor;
  parentId: number;
  voiceLinkId: number;
  chatLinkId: number;
  hasChildren: boolean;
  voiceLink: string;
  chatLink: DecisionChatLink;
  memberFirmIds: number[];
  supportAreaId: number;
}

export type Decision = RootCategory | Category | Solution;

export interface SolutionArticle extends ServiceNowArticle {
  id: number;
  number: string;
  shortDescription: string;
  html: string;
  countOfView: number;
  lastUpdatedAt: Date;
  lastUpdatedBy: string;
}

export interface SearchDecision {
  id: number;
  parentId: number;
  title: string;
  path: string[];
}

export interface SearchDecisions {
  items: SearchDecision[];
  keys: string[];
}

export interface LinkParameter {
  id: number;
  title: string;
}

export interface SearchSolutions {
  items: Solution[];
  keys: string[];
  categoryIds: string[];
}

export interface SearchTrendingPayload {
  keyword: string;
  memberFirmId: number;
}

export interface SearchTrendingPayload {
  keyword: string;
  memberFirmId: number;
}

export interface SearchTypeaheadPayload {
  keyword: string;
  memberFirmId: number;
}

export interface DecisionChatLink {
  id: number;
  link: string;
  title: string;
  workgroup: string;
  skill: string;
  apiKey: string;
}

export enum DecisionType {
  rootCategory = 1,
  category = 2,
  faq = 3,
  request = 4,
  externalLink = 5
}

export enum DecisionStatus {
  published = 1,
  draft = 2,
  inactive = 3,
  deleted = 4
}

export enum SolutionSource {
  serviceNow = 1,
  externalSite = 2
}

export enum ContainerFor {
  none = 0,
  category = 1,
  solution = 2
}

export enum IconType {
  computer = 1,
  download = 2,
  user_card = 3,
  lock = 4,
  buildings = 5,
  users = 6,
  money = 7,
  stack = 8,
  cashflow,
  collaboration,
  folder,
  graph,
  line_graph,
  people,
  screen,
  smartphone,
  verified,
  workspace
}
